import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {ResourcesHubEffects} from './core/resources-hub.effects';
import {reducer} from './core/resources-hub.reducer';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {
  AddResourceScreenComponent
} from './screens/add-resource-screen/add-resource-screen.component';
import {
  ResourceManagerHeaderComponent
} from './components/resource-manager-header/resource-manager-header.component';
import {
  AddCategoriesComponent
} from './components/add-categories/add-categories.component';
import {
  AddSectionComponent
} from './components/add-section/add-section.component';
import {MatMenuModule} from '@angular/material/menu';
import {
  AddContentComponent
} from './components/add-content/add-content.component';
import {
  ViewResourceScreenComponent
} from './screens/view-resource-screen/view-resource-screen.component';
import {
  CategoriesChipsComponent
} from './components/categories-chips/categories-chips.component';
import {
  ResourceSectionComponent
} from './components/resource-section/resource-section.component';
import {
  ResourceContentComponent
} from './components/resource-content/resource-content.component';
import {
  ResourceLayoutComponent
} from './components/resource-layout/resource-layout.component';
import {
  ResourceImageComponent
} from './components/resource-image/resource-image.component';
import {
  ResourceVideoPlayerComponent
} from './components/resource-video-player/resource-video-player.component';
import {
  ResourceLeftLayoutDirective
} from './directives/resource-left-layout.directive';
import {
  ResourceRightLayoutDirective
} from './directives/resource-right-layout.directive';
import {
  ResourceAccordionComponent
} from './components/resource-accordion/resource-accordion.component';
import {
  ResourceTextComponent
} from './components/resource-text/resource-text.component';
import {
  ResourceGoogleSlidePreviewComponent
} from './components/resource-google-slide-preview/resource-google-slide-preview.component';
import {
  ResourceMiddleLayoutDirective
} from './directives/resource-middle-layout.directive';
import {AddLayoutComponent} from './components/add-layout/add-layout.component';
import {AddVideoComponent} from './components/add-video/add-video.component';
import {AddImageComponent} from './components/add-image/add-image.component';
import {
  AddGoogleSlidesComponent
} from './components/add-google-slides/add-google-slides.component';
import {
  AddAccordionComponent
} from './components/add-accordion/add-accordion.component';
import {AddTextComponent} from './components/add-text/add-text.component';
import {
  AddResourcesLeftSectionDirective
} from './directives/add-resources-left-section.directive';
import {DragDropDirective} from './directives/drag-drop.directive';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {
  RelatedResourcesComponent
} from './components/related-resources/related-resources.component';
import {MaterialModule} from "../../shared/material-module";
import {
  AddAccordionFormComponent
} from './components/add-accordion-form/add-accordion-form.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {
  ResourceListScreenComponent
} from './screens/resource-list-screen/resource-list-screen.component';
import {
  ResourcesCardComponent
} from './components/resources-card/resources-card.component';


@NgModule({
  declarations: [
    AddResourceScreenComponent,
    ResourceManagerHeaderComponent,
    AddCategoriesComponent,
    AddSectionComponent,
    AddContentComponent,
    ViewResourceScreenComponent,
    CategoriesChipsComponent,
    ResourceSectionComponent,
    ResourceContentComponent,
    ResourceLayoutComponent,
    ResourceImageComponent,
    ResourceVideoPlayerComponent,
    ResourceLeftLayoutDirective,
    ResourceMiddleLayoutDirective,
    ResourceRightLayoutDirective,
    ResourceAccordionComponent,
    ResourceTextComponent,
    ResourceGoogleSlidePreviewComponent,
    AddLayoutComponent,
    AddVideoComponent,
    AddImageComponent,
    AddGoogleSlidesComponent,
    AddAccordionComponent,
    AddTextComponent,
    AddResourcesLeftSectionDirective,
    DragDropDirective,
    RelatedResourcesComponent,
    AddAccordionFormComponent,
    ResourceListScreenComponent,
    ResourcesCardComponent,
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    StoreModule.forFeature("ss-cord.resources-hub", reducer),
    EffectsModule.forFeature(
      [ResourcesHubEffects]
    ),
    MatMenuModule,
    CKEditorModule,
    MaterialModule,
    InfiniteScrollModule
  ],

  providers: [],
})
export class ResourcesHubModule {
}
